// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ContributionBatch } from './contribution-batch';
import { ContributionType } from './contribution-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ContributionPayment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  amount!: number;
  batchId!: number;
  checkNumber?: string;
  created?: Date;
  createdBy?: string;
  from?: string;
  modified?: Date;
  modifiedBy?: string;
  note?: string;
  rowVersion?: number;
  typeId?: number;
  batch!: ContributionBatch;
  type!: ContributionType;
}

